/**
 * Format a phone number for WhatsApp wa.me links.
 * Handles UK numbers (07xxx) and international formats (00xx, +xx).
 */
export function formatPhoneForWhatsApp(phone: string): string {
  // Remove all non-digits
  let digits = phone.replace(/\D/g, '');
  
  // Handle 00 international prefix (e.g., 004915772462931 -> 4915772462931)
  if (digits.startsWith('00')) {
    digits = digits.slice(2);
  }
  // Handle UK numbers starting with 0 (e.g., 07495584456 -> 447495584456)
  else if (digits.startsWith('0')) {
    digits = '44' + digits.slice(1);
  }
  
  return digits;
}
